<mat-spinner *ngIf="WaitingForCamera"></mat-spinner>
<div>
    <h2 class="text-dark">Scan the QR code For: {{data.eventTitle}}</h2>
    <h3 class="text-danger">{{error}}</h3>
    <zxing-scanner class="scanner" (camerasNotFound)="camerasNotFoundHandler($event)"
        (camerasFound)="camerasFoundHandler($event)" (scanError)="scanErrorHandler($event)"
        (scanSuccess)="scanSuccessHandler($event)" [enable]="qrEnabled">
    </zxing-scanner>
    <h2 class="text-muted">Warning Apple/IOS users will need to use Safari browsers to access the QR code scanner</h2>
</div>